import { jsx as _jsx } from "react/jsx-runtime";
const BannerTitle = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  className: "is--heading-7 m-y-0",
  children: children
});
BannerTitle.displayName = 'BannerTitle';
export default BannerTitle;